<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'PROFILE.HERO_EYEBROW' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'PROFILE.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'PROFILE.SUBTITLE' | translate }}</p>
    </div>
  </section>

  <section class="ph-section ph-section--muted">
    <div class="ph-container">
      <div *ngIf="isLoading" class="ph-profile-state">
        <div class="ph-profile-spinner" role="status" aria-live="polite">
          <span class="ph-profile-spinner__ring" aria-hidden="true"></span>
          <span>{{ 'PROFILE.LOADING' | translate }}</span>
        </div>
      </div>

      <div *ngIf="error && !isLoading" class="ph-profile-alert ph-profile-alert--error" role="alert">
        <i class="lni lni-warning" aria-hidden="true"></i>
        <p>{{ error | translate }}</p>
      </div>

      <div *ngIf="successMessage && !isLoading" class="ph-profile-alert ph-profile-alert--success" role="status">
        <i class="lni lni-checkmark-circle" aria-hidden="true"></i>
        <p>{{ successMessage | translate }}</p>
      </div>

      <div *ngIf="user && !isLoading" class="ph-profile-layout">
        <aside class="ph-profile-aside">
          <div class="ph-profile-card ph-profile-card--summary">
            <div class="ph-profile-avatar" aria-hidden="true">
              <span>{{ userInitials }}</span>
            </div>
            <h2 class="ph-profile-card__name">{{ displayName }}</h2>
            <p class="ph-profile-card__meta">{{ user.email }}</p>
            <span *ngIf="user.role" class="ph-profile-card__role">{{ user.role }}</span>
            <p class="ph-profile-card__hint">{{ 'PROFILE.READONLY_HINT' | translate }}</p>
          </div>

          <div class="ph-profile-card ph-profile-card--links">
            <h3 class="ph-profile-card__title">{{ 'PROFILE.QUICK_LINKS' | translate }}</h3>
            <a
              [href]="assistantHref"
              target="_blank"
              rel="noopener noreferrer"
              class="ph-profile-link">
              <i class="lni lni-dashboard" aria-hidden="true"></i>
              Propero Assistant
            </a>
            <a routerLink="/help" class="ph-profile-link">
              <i class="lni lni-question-circle" aria-hidden="true"></i>
              {{ 'HOME.HELP_CENTER_TITLE' | translate }}
            </a>
          </div>
        </aside>

        <div class="ph-profile-panel">
          <header class="ph-profile-panel__header">
            <h2 class="ph-profile-panel__title">{{ 'PROFILE.PERSONAL_INFO.TITLE' | translate }}</h2>
            <p class="ph-profile-panel__lead">{{ 'PROFILE.PERSONAL_INFO.EDIT' | translate }}</p>
          </header>

          <form (ngSubmit)="updateProfile()" #profileForm="ngForm" class="ph-profile-form" novalidate>
            <div class="ph-profile-form__grid">
              <div class="ph-field ph-field--readonly">
                <label for="profile-username">{{ 'PROFILE.USERNAME' | translate }}</label>
                <input
                  id="profile-username"
                  type="text"
                  class="ph-field__input"
                  [(ngModel)]="user.username"
                  name="username"
                  readonly />
              </div>

              <div class="ph-field ph-field--readonly">
                <label for="profile-role">{{ 'PROFILE.ROLE' | translate }}</label>
                <input
                  id="profile-role"
                  type="text"
                  class="ph-field__input"
                  [ngModel]="user.role"
                  name="role"
                  readonly />
              </div>

              <div class="ph-field">
                <label for="profile-email">{{ 'PROFILE.EMAIL' | translate }}</label>
                <input
                  id="profile-email"
                  type="email"
                  class="ph-field__input"
                  [(ngModel)]="user.email"
                  name="email"
                  required
                  email />
              </div>

              <div class="ph-field">
                <label for="profile-phone">{{ 'PROFILE.PHONE' | translate }}</label>
                <input
                  id="profile-phone"
                  type="tel"
                  class="ph-field__input"
                  [(ngModel)]="user.phoneNumber"
                  name="phoneNumber"
                  [placeholder]="'PROFILE.PHONE_PLACEHOLDER' | translate" />
              </div>

              <div class="ph-field">
                <label for="profile-first-name">{{ 'PROFILE.FIRST_NAME' | translate }}</label>
                <input
                  id="profile-first-name"
                  type="text"
                  class="ph-field__input"
                  [(ngModel)]="user.firstName"
                  name="firstName"
                  required />
              </div>

              <div class="ph-field">
                <label for="profile-middle-name">{{ 'PROFILE.MIDDLE_NAME' | translate }}</label>
                <input
                  id="profile-middle-name"
                  type="text"
                  class="ph-field__input"
                  [(ngModel)]="user.middleName"
                  name="middleName" />
              </div>

              <div class="ph-field">
                <label for="profile-last-name">{{ 'PROFILE.LAST_NAME' | translate }}</label>
                <input
                  id="profile-last-name"
                  type="text"
                  class="ph-field__input"
                  [(ngModel)]="user.lastName"
                  name="lastName"
                  required />
              </div>

              <div class="ph-field">
                <label for="profile-company">{{ 'PROFILE.COMPANY' | translate }}</label>
                <input
                  id="profile-company"
                  type="text"
                  class="ph-field__input"
                  [(ngModel)]="user.company"
                  name="company"
                  [placeholder]="'PROFILE.COMPANY_PLACEHOLDER' | translate" />
              </div>

              <div class="ph-field ph-field--full">
                <label for="profile-address">{{ 'PROFILE.ADDRESS' | translate }}</label>
                <input
                  id="profile-address"
                  type="text"
                  class="ph-field__input"
                  [(ngModel)]="user.address"
                  name="address"
                  [placeholder]="'PROFILE.ADDRESS_PLACEHOLDER' | translate" />
              </div>
            </div>

            <div class="ph-profile-form__actions">
              <button
                type="button"
                class="ph-btn ph-btn--outline"
                (click)="resetForm()"
                [disabled]="isSaving">
                {{ 'PROFILE.RESET_FORM' | translate }}
              </button>
              <button
                type="submit"
                class="ph-btn ph-btn--brand ph-btn--lg"
                [disabled]="!profileForm.form.valid || isSaving">
                <span *ngIf="!isSaving">{{ 'PROFILE.ACTIONS.SAVE' | translate }}</span>
                <span *ngIf="isSaving">{{ 'PROFILE.SAVING' | translate }}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>
